import PageMyAccount from "./PageAccount.vue";

const routes = {
  navigation: [
    {
      path: "/account",
      name: "MyAccount",
      component: PageMyAccount,
    },
  ],
};

export default routes;
